import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { App } from 'antd';
import Home from './presentation/navigation/Home/Home.component';
import AppLayout from './layouts/AppLayout';
import Adverts from './presentation/navigation/Adverts/Adverts.component';
import Channels from './presentation/navigation/Channels/Channels.component';
import AdvertsCreate from './presentation/navigation/AdvertsCreate/AdvertsCreate.component';
import AdvertsEdit from './presentation/navigation/AdvertsEdit/AdvertsEdit.component';
import Advert from './presentation/navigation/Advert/Advert.component';
import Channel from './presentation/navigation/Channel/Channel.component';
import SignUpRoute from './presentation/navigation/User/SignUpRoute.component';
import LoginRoute from './presentation/navigation/User/LoginRoute.component';
import LeadsRoute from './presentation/navigation/Lead/LeadsRoute.component';
import PrivateRoute from './presentation/navigation/PrivateRoute.component';
import AdminRoute from './presentation/navigation/AdminRoute.component';
import AdminChannels from './presentation/navigation/AdminChannels/AdminChannels.component';
import AdminChannelImport from './presentation/navigation/AdminChannelImport/AdminChannelImport.component';
import AdminDeliveries from './presentation/navigation/AdminDeliveries/AdminDeliveries.component';
import AdminCrawlers from './presentation/navigation/AdminCrawlers/AdminCrawlers.component';
import AdminMessenger from './presentation/navigation/AdminMessenger/AdminMessenger.component';
import AdminDiscoveredChannels from './presentation/navigation/AdminDiscoveredChannels/AdminDiscoveredChannels.component';
import { AuthContextProvider } from './middleware/UserContext/UserContext.middleware';
import './App.css';
import TelegramAccounts from './presentation/navigation/TelegramAccounts/TelegramAccounts.component';
import TelegramAccountsCreate from './presentation/navigation/TelegramAccountsCreate/TelegramAccountsCreate.component';
import TelegramAccountBranding from './presentation/navigation/TelegramAccountBranding/TelegramAccountBranding.component';

const AdvertizerApp: React.FC = () => {
  return (
    <App>
      <AuthContextProvider>
        <Routes>
          <Route path="/" element={<AppLayout />}>
            <Route index element={<Home />} />
            <Route path="/adverts" element={<PrivateRoute><Adverts /></PrivateRoute>} />
            <Route path="/adverts/create" element={<PrivateRoute><AdvertsCreate /></PrivateRoute>} />
            <Route path="/adverts/:advertId/edit" element={<PrivateRoute><AdvertsEdit /></PrivateRoute>} />
            <Route path="/adverts/:advertId" element={<PrivateRoute><Advert /></PrivateRoute>} />
            <Route path="/channels" element={<PrivateRoute><Channels /></PrivateRoute>} />
            <Route path="/channels/:channelId" element={<PrivateRoute><Channel /></PrivateRoute>} />
            <Route path="/sign_up" element={<SignUpRoute />} />
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/leads" element={<AdminRoute><LeadsRoute /></AdminRoute>} />
            <Route path="/telegram_accounts" element={<PrivateRoute><TelegramAccounts /></PrivateRoute>} />
            <Route path="/telegram_accounts/create" element={<PrivateRoute><TelegramAccountsCreate /></PrivateRoute>} />
            <Route path="/telegram_accounts/:uuid/branding" element={<PrivateRoute><TelegramAccountBranding /></PrivateRoute>} />
            <Route path="/admin/channels" element={<AdminRoute><AdminChannels /></AdminRoute>} />
            <Route path="/admin/channels/import" element={<AdminRoute><AdminChannelImport /></AdminRoute>} />
            <Route path="/admin/deliveries" element={<AdminRoute><AdminDeliveries /></AdminRoute>} />
            <Route path="/admin/crawlers" element={<AdminRoute><AdminCrawlers /></AdminRoute>} />
            <Route path="/admin/messenger" element={<AdminRoute><AdminMessenger /></AdminRoute>} />
            <Route path="/admin/discovered-channels" element={<AdminRoute><AdminDiscoveredChannels /></AdminRoute>} />
          </Route>
        </Routes>
      </AuthContextProvider>
    </App>
  );
};

export default AdvertizerApp;